export default __webpack_public_path__ + "static/logo-small-a9f78f8013cd3b3315218d13603abf1a.png";